import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=a3e5e962&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Events.vue"
export default component.exports